<div class="drawer-content">
    <mat-nav-list>
        <mat-accordion>
            @for (product of PRODUCTS; track product) {
                <mat-expansion-panel [expanded]="activeRoute === product.route">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <div class="text-[16px] text-white">{{ product.label }}</div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    @for (sub of product.subProducts; track sub) {
                        <mat-list-item routerLink="{{ sub.route }}" routerLinkActive="active">
                            <div class="flex items-center gap-[8px]">
                                <mat-icon class="text-white">{{ sub.icon }}</mat-icon>
                                <div class="product-label text-[16px] text-white">{{ sub.label }}</div>
                            </div>
                        </mat-list-item>
                    }
                </mat-expansion-panel>
            }
        </mat-accordion>
    </mat-nav-list>
</div>
